"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Main = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Section = require("./Section");
var _SectionContact = require("./SectionContact");
require("./Main.scss");
var Main = function Main(_ref) {
  var className = _ref.className,
    contact = _ref.contact,
    sections = _ref.sections;
  var Section = Main.Section,
    SectionContact = Main.SectionContact;
  var rootClassName = (0, _classnames["default"])('cds-FooterMain', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterMain-Content container"
  }, contact && /*#__PURE__*/_react["default"].createElement(Section, {
    label: contact.label,
    content: /*#__PURE__*/_react["default"].createElement(SectionContact, {
      contact: contact
    })
  }), sections.length > 0 && sections.map(function (section, index) {
    return /*#__PURE__*/_react["default"].createElement(Section, (0, _extends2["default"])({}, section, {
      key: (0, _key.createKey)(index, section.label)
    }));
  })));
};
exports.Main = Main;
Main.Section = _Section.Section;
Main.SectionContact = _SectionContact.SectionContact;